// Mock data for Fira website

export const announcementData = {
  text: "FIRA SMART DESK DILANCARKAN PADA 5 FEBRUARI",
  // February 5, 2026 at 11:00 AM Malaysia Time (GMT+8)
  targetDate: "2026-02-05T11:00:00+08:00"
};

export const heroData = {
  title: "Fira Tak Nak Jual Mimpi.",
  subtitle: [
    "Sebab anda dah muak dengan screenshot profit palsu.",
    "Dah penat dengan \"sifu\" yang hilang bila anda tanya soalan.",
    "Dah bosan dengan signal group yang win rate \"99%\" tapi akaun anda tetap merah."
  ]
};

export const storyData = {
  intro: "Fira nak cerita benda lain.",
  highlight: "I nak cerita pasal 3:47 pagi.",
  title: "3:47 Pagi. Mata Merah. Akaun Merah.",
  content: [
    "Anda kenal perasaan tu.",
    "Satu candle. Satu news. Satu \"tak sangka\"",
    "Dan semua profit seminggu — Loss dalam 10 minit.",
    "Anda tutup handphone.",
    "Baring atas katil.",
    "Mata tengok siling.",
    '\"Aku dah ikut setup. Aku dah buat analysis. Kenapa masih salah?\"',
    "Lepas tu anda buat benda yang sama macam semua trader buat:",
    "Bangun esok. Dan trade lagi.",
    "Sebab dalam hati anda tahu — anda tak nak give up.",
    "Anda cuma perlukan sesuatu yang betul-betul bantu."
  ]
};

export const ctaLink = "https://t.me/+tdAS5Mwbvog4YTQ1";

export const logoUrl = "https://customer-assets.emergentagent.com/job_618cd302-26c2-4845-b940-fc1c769b2643/artifacts/94mbl6az_FIRA%20INDICATOR%20BLACK.png";
